import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthAccessService } from "./auth-access.service";

@Injectable({
  providedIn: "root",
})
export class RouteGuard implements CanActivate {
  constructor(private authAccessService: AuthAccessService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authAccessService.canAccess(next, state);
  }
}
